/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Missing_Team_Project_Id_ErrorInputs */



/**
* | output |
* | --- |
* | "Missing team or project ID in file" |
*
* @param {Explorer_Search_Missing_Team_Project_Id_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_missing_team_project_id_error = /** @type {((inputs?: Explorer_Search_Missing_Team_Project_Id_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Missing_Team_Project_Id_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Missing team or project ID in file")
	if (locale === "de") return /** @type {LocalizedString} */ ("Missing team or project ID in file")
	if (locale === "it") return /** @type {LocalizedString} */ ("Missing team or project ID in file")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Missing team or project ID in file")
	if (locale === "es") return /** @type {LocalizedString} */ ("Missing team or project ID in file")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Missing team or project ID in file")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Missing team or project ID in file")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Missing team or project ID in file")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Missing team or project ID in file")
	return /** @type {LocalizedString} */ ("Missing team or project ID in file")
});